export const login = {
  namespaced: true,
  namespace: 'login',
  state: {
    userInfo: null,
    authToken: '',
    authorizationLimit: [], //存用户权限
    limitShow: true, //权限
    isMobile: false,
    visibleEx: false,
    minioOption: null
  },
  mutations: {
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
    },
    setAuthToken(state, authToken) {
      state.authToken = authToken;
    },
    setAuthorizationLimit(state, authorizationLimit) {
      state.authorizationLimit = authorizationLimit;
    },
    setLimitShow(state, limitShow) {
      state.limitShow = limitShow;
    },
    setIsMobile(state, isMobile) {
      state.isMobile = isMobile;
    },
    setVisibleEx(state, visibleEx) {
      state.visibleEx = visibleEx;
    },
    setMinioOption(state, minioOption) {
      state.minioOption = minioOption;
    }
  },
  getters: {
    userInfo: state => state.userInfo,
    authToken: state => state.authToken,
    authorizationLimit: state => state.authorizationLimit,
    limitShow: state => state.limitShow,
    isMobile: state => state.isMobile
  },
  actions: {
    changeUserInfo({ commit }, flag) {
      commit('setUserInfo', flag);
    },
    changeAuthToken({ commit }, flag) {
      commit('setAuthToken', flag);
    },
    changeAuthorizationLimit({ commit }, flag) {
      commit('setAuthorizationLimit', flag);
    }
  }
};
